export default "__VITE_ASSET__a091a6bc__"